import { styled } from '@mui/material';
import type { Ref } from 'react';
import { NavLink } from 'react-router-dom';
import type { MenuButtonProps } from './MenuButton';
import { MenuButton } from './MenuButton';

interface MenuNavButtonProps extends MenuButtonProps {
  url: string;
  end: boolean;
  navRef?: React.RefObject<HTMLAnchorElement | null>;
}

const StyledNavLink = styled(NavLink)(() => ({
  width: '100%',
  height: 'auto',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  '&.active': {
    backgroundColor: 'transparent',
  },
  textDecoration: 'none',
}));

export const MenuNavButton = ({ end, name, icon, url, navRef, enableToolTip, isSideBarOpen }: MenuNavButtonProps) => {
  return (
    <StyledNavLink end={end} to={url} ref={navRef as Ref<HTMLAnchorElement> | undefined} className={'navLink'}>
      {({ isActive }) => (
        <MenuButton
          icon={icon}
          name={name}
          isActive={isActive}
          isSideBarOpen={isSideBarOpen}
          enableToolTip={enableToolTip}
        />
      )}
    </StyledNavLink>
  );
};
